function stripBlockComments(content) {
    return content.replace(/\/\*[\s\S]*?\*\//g, "");
}

function stripLineComments(block) {
    return block
        .split("\n")
        .map(line => {
            let quote = null;
            for (let i = 0; i < line.length; i++) {
                const ch = line[i];
                if (quote) {
                    if (ch === quote) quote = null;
                } else if (ch === "'" || ch === '"') {
                    quote = ch;
                } else if (ch === "-" && line[i + 1] === "-") {
                    return line.slice(0, i);
                }
            }
            return line;
        })
        .join("\n");
}

function extractBlock(content, startIdx) {
    let depth = 1;
    let quote = null;
    let i = startIdx;

    while (i < content.length) {
        const ch = content[i];
        if (quote) {
            if (ch === quote) quote = null;
        } else {
            if (ch === "'" || ch === '"') quote = ch;
            else if (ch === "(") depth++;
            else if (ch === ")") {
                depth--;
                if (depth === 0) break;
            }
        }
        i++;
    }
    return content.slice(startIdx, i);
}

function splitByComma(block) {
    const parts = [];
    let current = "";
    let quote = null;

    for (const ch of block) {
        if (quote) {
            if (ch === quote) quote = null;
            current += ch;
        } else if (ch === "'" || ch === '"') {
            quote = ch;
            current += ch;
        } else if (ch === ",") {
            parts.push(current.trim());
            current = "";
        } else {
            current += ch;
        }
    }
    if (current.trim()) parts.push(current.trim());
    return parts;
}

function coerceValue(raw) {
    const v = raw.trim();
    if ((v.startsWith("'") && v.endsWith("'")) || (v.startsWith('"') && v.endsWith('"'))) {
        return v.slice(1, -1);
    }
    const lower = v.toLowerCase();
    if (lower === "true") return true;
    if (lower === "false") return false;
    const n = Number(v);
    if (v !== "" && !isNaN(n)) return n;
    return v;
}

function parseProperties(block) {
    const cleaned = stripLineComments(block);
    const props = {};
    const pairs = splitByComma(cleaned);
    for (const pair of pairs) {
        const colonIdx = pair.indexOf(":");
        if (colonIdx === -1) continue;
        const key = pair.slice(0, colonIdx).trim();
        const value = coerceValue(pair.slice(colonIdx + 1));
        if (key) props[key] = value;
    }
    return props;
}

export const parse = tqlContent => {
    const content = stripBlockComments(tqlContent);
    const result = [];
    const regex = /CREATE\s+(?:OR\s+REPLACE\s+)?(SOURCE|TARGET)\s+[\w.]+\s+USING\s+([\w.]+)\s*\(/gi;
    let match;

    while ((match = regex.exec(content)) !== null) {
        const fullAdapterName = match[2];
        const adapter = fullAdapterName.includes(".") ? fullAdapterName.split(".").pop() : fullAdapterName;

        const blockStart = match.index + match[0].length;
        const block = extractBlock(content, blockStart);
        const properties = parseProperties(block);

        result.push({ adapter, properties });
    }

    return result;
};
